//  shadi-arts-portfolio Firebase\client\src\components\Admin\PricingManager.jsx 

import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useLanguage } from "../../context/LanguageContext";

const PricingManager = () => {
  const { t } = useLanguage();
  const [pricing, setPricing] = useState({
    single: 0,
    couple: 0,
    family: 0,
    pet: 0,
    celebrity: 0,
    frame: 0,
    delivery_physical: 0,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchPricing();
  }, []);

  const fetchPricing = async () => {
    try {
      const docRef = doc(db, "pricing", "current");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setPricing(docSnap.data());
      }
    } catch (error) {
      console.error("Error fetching pricing:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setPricing({ ...pricing, [field]: parseInt(value) || 0 });
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const docRef = doc(db, "pricing", "current");
      await updateDoc(docRef, {
        ...pricing,
        updatedAt: new Date().toISOString(),
      });
      alert(t("Pricing updated successfully!", "تم تحديث الأسعار بنجاح!"));
    } catch (error) {
      console.error("Error saving pricing:", error);
      alert(t("Error saving pricing", "حدث خطأ أثناء حفظ الأسعار"));
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <div className="loading">
        {t("Loading pricing...", "جاري تحميل الأسعار...")}
      </div>
    );

  return (
    <div className="pricing-manager">
      <h3>{t("💰 Pricing Configuration", "💰 إعدادات التسعير")}</h3>
      <p className="pricing-note">
        {t(
          "Update prices here — they will automatically update the order form.",
          "قم بتحديث الأسعار هنا — سيتم تحديث نموذج الطلب تلقائياً.",
        )}
      </p>

      <div className="pricing-grid">
        <div className="pricing-card">
          <label>{t("🖼️ Single Portrait", "🖼️ بورتريه فردي")}</label>
          <input
            type="number"
            value={pricing.single}
            onChange={(e) => handleChange("single", e.target.value)}
          />
          <span className="currency">EGP</span>
        </div>

        <div className="pricing-card">
          <label>{t("👫 Couple Portrait", "👫 بورتريه مزدوج")}</label>
          <input
            type="number"
            value={pricing.couple}
            onChange={(e) => handleChange("couple", e.target.value)}
          />
          <span className="currency">EGP</span>
        </div>

        <div className="pricing-card">
          <label>{t("👨‍👩‍👧‍👦 Family Portrait", "👨‍👩‍👧‍👦 بورتريه عائلي")}</label>
          <input
            type="number"
            value={pricing.family}
            onChange={(e) => handleChange("family", e.target.value)}
          />
          <span className="currency">EGP</span>
        </div>

        <div className="pricing-card">
          <label>{t("🐾 Pet Portrait", "🐾 بورتريه حيوان أليف")}</label>
          <input
            type="number"
            value={pricing.pet}
            onChange={(e) => handleChange("pet", e.target.value)}
          />
          <span className="currency">EGP</span>
        </div>

        <div className="pricing-card">
          <label>{t("⭐ Celebrity Portrait", "⭐ بورتريه مشاهير")}</label>
          <input
            type="number"
            value={pricing.celebrity}
            onChange={(e) => handleChange("celebrity", e.target.value)}
          />
          <span className="currency">EGP</span>
        </div>

        <div className="pricing-card">
          <label>{t("🖼️ Framing (optional)", "🖼️ إطار (اختياري)")}</label>
          <input
            type="number"
            value={pricing.frame}
            onChange={(e) => handleChange("frame", e.target.value)}
          />
          <span className="currency">EGP</span>
        </div>

        <div className="pricing-card">
          <label>{t("🚚 Physical Delivery", "🚚 توصيل مادي")}</label>
          <input
            type="number"
            value={pricing.delivery_physical}
            onChange={(e) => handleChange("delivery_physical", e.target.value)}
          />
          <span className="currency">EGP</span>
        </div>
      </div>

      <button onClick={handleSave} disabled={saving} className="btn-gold">
        {saving
          ? t("Saving...", "جاري الحفظ...")
          : t("Save Pricing", "حفظ الأسعار")}
      </button>
    </div>
  );
};

export default PricingManager;
